import { useDataContext } from 'context/data-context';
//import { useAppContext } from 'context/app-context';
/*import kz from 'locale/kz'*/
import ru from 'locale/ru';
import uz from 'locale/uz';

const locales = {
  /*kz,*/
  ru,
  uz,
};

export const useLocale = () => {
  const { appLocale } = useDataContext();

  return {
    ...locales[appLocale],
    lang: appLocale,
    localize: (textUz?: string, textRu?: string) => (appLocale === 'uz' ? textUz : textRu),
  };
};
